<template>
  <div class="page-wrapper">
    <img src="../image/ajax-loader.gif" v-show="waitingApiRequestsCount != 0"
         style="margin: 0; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); z-index: 10">
    <dailySchedule :isVisible="isScheduleWindowVisible"
                   @close-window="changeScheduleWindowVisibility"
                   :worker="clickedWorker"
                   :day="clickedWorkerDay"
                   :schedule="clickedWorkerSchedule"
    ></dailySchedule>
    <scheduleTemplate
      :isVisible="isScheduleTemplateWindowVisible"
      :workersIdList="selectedWorkers"
      @close-window="changeScheduleTemplateWindowVisibility"
    ></scheduleTemplate>

    <menu-dispatcher></menu-dispatcher>
    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="workers-base-container">
        <div class="cabinet">
          <alert-window ref="alertWindow"></alert-window>
          <div class="cabinet-head workers-head visibility">
            <div class="title">База рабочих</div>
            <div class="workers-marking">
              <section>
                <span class="color green"></span>Рабочая смена
              </section>
              <section>
                <span class="color red"></span>Выходной
              </section>
              <section>
                <img src="../image/moon.png" alt="Ночная смена" title="Ночная смена">Ночная смена
              </section>
              <section>
                <img src="../image/hospital.png" alt="Болен" title="Болен">Болен
              </section>
              <section>
                <img src="../image/released.png" alt="Освобожден" title="Освобожден">Освобожден
              </section>
            </div>
          </div>
          <div class="cabinet-body">
            <div class="cabinet-info">
              <div class="cabinet-settings workers-settings">
                <div class="first-string visibility">

                  <div class="date-select block">
                    <fieldset>
                      <div class="vdp-datepicker block-icon"><span class="icon"><i class="fa fa-calendar-o"></i></span>
                        <date-picker
                                v-model="workersBaseFilters.dateFrom"
                                ref="datePickerFrom"
                                format="DD.MM.YYYY"
                                lang="ru"
                                v-mask="'##.##.####'"
                                placeholder="__.__.____"
                                :clearable="false"
                                :first-day-of-week="1"
                                @input="onChangeDateFilterFrom"
                                @panel-change="changePanelDatePickerFrom">
                        </date-picker>
                      </div>
                      <span class="dash">-</span>
                      <div class="vdp-datepicker block-icon"><span class="icon"><i class="fa fa-calendar-o"></i></span>
                        <date-picker
                                v-model="workersBaseFilters.dateTo"
                                ref="datePickerTo"
                                format="DD.MM.YYYY"
                                lang="ru"
                                v-mask="'##.##.####'"
                                placeholder="__.__.____"
                                :clearable="false"
                                :first-day-of-week="1"
                                @input="onChangeDateFilterTo"
                                @panel-change="changePanelDatePickerTo">
                        </date-picker>
                      </div>
                      <button type="button" class="button" @click="updateWorkers(workersBaseFilters.dateFrom, workersBaseFilters.dateTo)">
                        Применить
                      </button>
                    </fieldset>
                  </div>

                  <div class="template" @click="changeScheduleTemplateWindowVisibility(true)">
                    <div class="template-button">
                      <span class="icon"><i class="fa fa-table"></i></span>
                      <span class="text">Применить шаблон</span>
                    </div>
                  </div>
                  <router-link to="/workers-base/worker-card/new"
                               v-if="show(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HR', 'ROLE_DISPATCHER'])">
                    <div class="add-button">
                      <button type="button" class="add add-worker"><i>+</i> Добавить
                      </button>
                    </div>
                  </router-link>
                </div>
                <div class="dop-block visibility">
                  <div @click="workersBaseFilters.showAddFilters = !workersBaseFilters.showAddFilters" v-show="!workersBaseFilters.showAddFilters" class="dop-link block-open">
                    <span class="text">Дополнительно<i class="fa fa-angle-down"></i></span>
                  </div>
                  <div v-show="workersBaseFilters.showAddFilters" class="dop-filters visibility">
                    <div class="search block block-icon">
                      <span class="icon"><i class="fa fa-search"></i></span>
                      <fieldset><input type="text" placeholder="Поиск по ФИО или телефону"
                                       v-model="workersBaseFilters.workerNameOrPhoneFilter"></fieldset>
                    </div>
                    <div class="type block">
                      <select v-model="workersBaseFilters.workerTypeFilter">
                        <option :value="null">Тип исполнителя</option>
                        <option :value="'Грузчик'">Грузчик</option>
                        <option :value="'Водитель'">Водитель</option>
                        <option :value="'Мебельщик'">Мебельщик</option>
                        <option :value="'Водитель мусоровоза'">Водитель мусоровоза</option>
                      </select>
                    </div>
                    <div class="category block">
                      <select v-model="workersBaseFilters.workerCategoryFilter">
                        <option :value="null">Категория</option>
                        <option v-for="category in categories" :value="category.name">
                          {{ category.name }}
                        </option>
                      </select>
                    </div>
                    <div class="blocking">
                      <label :class="{checked: workersBaseFilters.areBlockedWorkersVisible}">
                        <input type="checkbox" v-model="workersBaseFilters.areBlockedWorkersVisible">
                        <span>Заблокированные</span>
                      </label>
                    </div>
                    <div class="blocking">
                      <label :class="{checked: workersBaseFilters.areDismissWorkersVisible}">
                        <input type="checkbox" v-model="workersBaseFilters.areDismissWorkersVisible">
                        <span>Уволенные</span>
                      </label>
                    </div>
                    <div @click="workersBaseFilters.showAddFilters = !workersBaseFilters.showAddFilters" class="dop-link block-close">
                      <span class="text">Скрыть<i class="fa fa-angle-up"></i></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cabinet-box">
                <div class="cabinet-table workers-table page-scroll">
                  <table cellpadding="0" cellspacing="0" class="workers-base">
                    <thead>
                    <tr>
                      <td class="checkbox">
                        <input type="checkbox" title="Выбрать всех" :checked="isSelectAll" @click="selectAll">
                      </td>
                      <td class="numb">
                        №
                      </td>
                      <td>Рабочий</td>
                      <template v-for="(day) of formattedDaysRangeForTableHeader">
                        <td class="day">{{ day }}</td>
                      </template>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(worker, i) in filteredWorkers">
                      <td class="checkbox">
                        <input type="checkbox" :value="worker.id" v-model="selectedWorkers">
                      </td>
                      <td class="numb">
                        {{ i + 1 }}
                      </td>
                      <td class="worker" @click="openWorker(worker.id)">
                        {{ [worker.surname, worker.name, worker.patronymic].join(" ") }},
                        <div v-if="worker.comment" class="comment"><span class="icon fa fa-comment"></span><span
                                class="text">{{ worker.comment }}</span></div>
                        <div class="dop-info">
                          <span class="type">{{ worker.type }},</span><span
                          class="category"> {{ getWorkerCategories(worker) }},</span> <span class="phone">{{ worker.phone }}</span>
                        </div>
                      </td>
                      <template v-for="(d, index) in formattedDaysForScheduleMap">
                        <td @click="changeScheduleWindowVisibility(true, worker, d, worker.scheduleMap[d])"
                            class="day edit-schedule"
                            v-bind:class="{

                            'work-time': (worker.scheduleMap[d].some(x => ((x.wsc_id && !x.wsc_worker_hill && !x.wsc_holiday && !x.wsc_weekend))) && (!((formattedDaysForScheduleMap[index - 1] && worker.scheduleMap[formattedDaysForScheduleMap[index - 1]]
              .some(x => (x.wsc_start_work_time !== '00:00' && x.wsc_end_work_time === '23:59'))) && worker.scheduleMap[d].some(x => ((x.wsc_start_work_time === '00:00')))) || (formattedDaysForScheduleMap[index + 1] && worker.scheduleMap[formattedDaysForScheduleMap[index + 1]]
              .some(x => x.wsc_start_work_time === '00:00')))) || (worker.scheduleMap[d].some(x => ((x.wsc_id && !x.wsc_worker_hill && !x.wsc_holiday && !x.wsc_weekend) && (x.wsc_start_work_time !== '00:00')))),

                            'day-off':  (worker.scheduleMap[d].every(x => !((x.wsc_id && !x.wsc_worker_hill && !x.wsc_holiday && !x.wsc_weekend)
                             && !((x.wsc_start_work_time === '00:00'))))) &&
                              (worker.scheduleMap[d].some(x => (x.wsc_id && (x.wsc_weekend || x.wsc_worker_hill || x.wsc_holiday))))
                            }">
                          <img v-show="worker.scheduleMap[d].some(x => x.wsc_worker_hill)" src="../image/hospital.png"
                               alt="Болен" title="Болен">
                          <img v-show="worker.scheduleMap[d].some(x => x.wsc_holiday)" src="../image/released.png"
                               alt="Освобожден" title="Освобожден">
                          <img
                            v-show="isNightShift(worker, d, index)"
                            src="../image/moon.png" alt="Ночная смена" title="Ночная смена">
                          <i class="fa fa-user-times lay-off" title="Уволен"
                             v-show="worker.dismiss && (moment(d).isSame(moment().set({'year': worker.dismissDate[0],
                             'month': worker.dismissDate[1] - 1, 'date': worker.dismissDate[2]}), 'day'))"></i>
                          <div class="summ">{{ worker.salaryMap[d] }}</div>
                        </td>
                      </template>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MenuDispatcher from '@/components/MenuDispatcher.vue'
  import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
  import ScheduleTemplate from '@/views/ScheduleTemplate.vue'
  import DailySchedule from '@/views/DailySchedule.vue'
  import api from '@/api'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'
  import DatePicker from 'vue2-datepicker'
  import moment from 'moment'
  import {extendMoment} from 'moment-range'
  import AlertWindow from '@/components/AlertWindow.vue'

  export default {
  name: 'WorkersBase',
  components: { DatePicker, DailySchedule, HeaderDispatcher, MenuDispatcher, ScheduleTemplate, AlertWindow },

    directives: {mask},

  data () {
    return {
      workers: [],
      isScheduleTemplateWindowVisible: false,
      isScheduleWindowVisible: false,
      clickedWorker: {},
      clickedWorkerDay: {},
      clickedWorkerSchedule: {},
      driverCategories: [],
      furnitureCategories: [],
      moverCategories: [],
      garbageCategories: [],
      isActualDataPresent: true,
      selectedWorkers: [],
    }
  },

  computed: {
    waitingApiRequestsCount () {
      return this.$store.getters.waitingApiRequestsCount
    },

    filteredWorkers () {
      this.selectedWorkers = []; // Сбрасываем выбранных рабочих при смене фильтра

      return this.workers.filter(w => {
        return this.workersBaseFilters.workerNameOrPhoneFilter == null ||
            w.surname.concat(' ', w.name).concat(' ', w.patronymic).toLowerCase().indexOf(this.workersBaseFilters.workerNameOrPhoneFilter.toLowerCase()) > -1 ||
            w.phone.indexOf(this.workersBaseFilters.workerNameOrPhoneFilter) > -1
      })
        .filter(w => {
          return w.type == this.workersBaseFilters.workerTypeFilter || this.workersBaseFilters.workerTypeFilter == null
        })
        .filter(w => {
          return w.categories.indexOf(this.workersBaseFilters.workerCategoryFilter) > -1 || this.workersBaseFilters.workerCategoryFilter == null
        })
        .filter(worker => {
          return !(this.workersBaseFilters.areBlockedWorkersVisible && this.workersBaseFilters.areDismissWorkersVisible) || (worker.dismiss && worker.inBlackList)
        })
        .filter(worker => {
          return !(!this.workersBaseFilters.areBlockedWorkersVisible && !this.workersBaseFilters.areDismissWorkersVisible) || (!worker.dismiss && !worker.inBlackList)
        })
        .filter(worker => {
          return !(this.workersBaseFilters.areDismissWorkersVisible && !this.workersBaseFilters.areBlockedWorkersVisible) || (worker.dismiss)
        })
        .filter(worker => {
          return !(!this.workersBaseFilters.areDismissWorkersVisible && this.workersBaseFilters.areBlockedWorkersVisible) || (worker.inBlackList)
        })
        // .filter(worker => {
        //   return !worker.inBlacklist || this.workersBaseFilters.areBlockedWorkersVisible
        // })
    },
    categories () {
      switch (this.workersBaseFilters.workerTypeFilter) {
        case 'Водитель':
          return this.driverCategories
        case 'Мебельщик':
          return this.furnitureCategories
        case 'Грузчик':
          return this.moverCategories
        case 'Водитель мусоровоза':
          return this.garbageCategories
        default:
          return []
      }
    },
    daysRange () {
      const Moment = extendMoment(moment)
      if (this.isActualDataPresent) {
        let range = Moment.range(this.workersBaseFilters.dateFrom, this.workersBaseFilters.dateTo).by('day')
        localStorage.daysRange = Array.from(range).map(m => m.toISOString())
        return Array.from(range)
      } else {
        let rangeFromStorage = localStorage.getItem('daysRange').split(',')
        return Array.from(Moment.range(Moment(rangeFromStorage[0]), Moment(rangeFromStorage[rangeFromStorage.length - 1])).by('day'))
      }
    },
    formattedDaysRangeForTableHeader () {
      let shortNamesOfDays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
      let r = []
      let range = this.daysRange
      for (let i = 0; i < range.length; i++) {
        r.push(shortNamesOfDays[new Date(range[i]).getDay()] + moment(range[i]).format(', DD.MM.'))
      }
      return r
    },
    formattedDaysForScheduleMap () {
      let range = this.daysRange
      let r = []
      for (let i = 0; i < range.length; i++) {
        r.push(moment(range[i]).format('YYYY-MM-DD'))
      }
      return r
    },
    isSelectAll() {
      return this.filteredWorkers
        && this.filteredWorkers.length > 0
        && this.selectedWorkers.length == this.filteredWorkers.length;
    },
    workersBaseFilters: {
      get(){
        return this.$store.getters.workersBaseFilters
      },
      set(){
        this.$store.commit('updateWorkersBaseFilters', this.workersBaseFilters)
      }
    }
  },

  mounted () {
    document.getElementsByTagName('body')[0].classList.add('cabinet-page', 'body-scroll')

    this.addDatePickerWatchers();

    api.getFurnitureCategories()
      .then((categories) => {
        this.furnitureCategories = categories
      })

    api.getMoverCategories()
      .then((categories) => {
        this.moverCategories = categories
      })

    api.getGarbageRemovalCategories()
      .then((categories) => {
        this.garbageCategories = categories
      })

    api.getTruckingCategories()
      .then((categories) => {
        this.driverCategories = categories
      })

    this.setFilterDefaultValuesIfUserCameNotFromWorkerCard()
    this.updateWorkers(new Date(this.workersBaseFilters.dateFrom).getTime(), new Date(this.workersBaseFilters.dateTo).getTime())

    const Moment = extendMoment(moment)
    let rang = Moment.range(moment(this.workersBaseFilters.dateFrom), moment(this.workersBaseFilters.dateTo)).by('day')


    localStorage.daysRange = Array.from(rang).map(m => m.toISOString())
  },

  watch: {
    workerTypeFilter () {
      if (!this.wasWorkerCategoryChangeCameFromStore) {
        this.workersBaseFilters.workerCategoryFilter = null
      }
      this.wasWorkerCategoryChangeCameFromStore = false

    }
  },

  methods: {
    changePanelDatePickerFrom(panel) {
      if (panel !== 'NONE')
        this.$refs.datePickerTo.popupVisible = false;
    },

    changePanelDatePickerTo(panel) {
      if (panel !== 'NONE')
        this.$refs.datePickerFrom.popupVisible = false;
    },

    show (accessForRoles) {
      return utils.checkRole(this.$store.getters.roleCode, accessForRoles)
    },

    getWorkerCategories (worker) {
      return worker.categories ? worker.categories.join(', ') : ''
    },

    updateWorkers (dateFrom, dateTo) {
      this.isActualDataPresent = false

      return api.getAllWorkersSchedule(dateFrom, dateTo)
        .then((workers) => {
          this.workers = workers
          this.isActualDataPresent = true
        })
        .catch(e => console.log(e))
    },

    moment (val) {
      return val ? moment(val) : moment()
    },

    isNightShift(worker, d, index) {
      return worker.scheduleMap[d]
          .filter(x => x.wsc_id
              && !x.wsc_worker_hill
              && !x.wsc_holiday
              && !x.wsc_weekend)
          .some(x => {
            let startHour = Number(x.wsc_start_work_time.substr(0, 2));
            return startHour >= 21
                || (startHour < 7
                    && (index == 0 // Если это первый день в выборке и начинается ночью, отмечать его ночной сменой
                        || x.wsc_start_work_time !== '00:00'
                        || (this.formattedDaysForScheduleMap[index - 1]
                            // Если в предыдущий день смена примыкает вплотную к 00:00,
                            // считать это ночной сменой предыдущего дня
                            && !worker.scheduleMap[this.formattedDaysForScheduleMap[index - 1]]
                                .some(x => x.wsc_end_work_time == '23:59'))
                    ))
          });
    },

    setFilterDefaultValuesIfUserCameNotFromWorkerCard: function () {
      if(!this.$store.getters.isWorkerBaseRequestedFromWorkerCard) {
        this.$store.commit('resetWorkersBaseFilters')
      } else {
        this.$store.commit('updateIsWorkerBaseRequestedFromWorkerCard', false)
      }
    },

    changeScheduleTemplateWindowVisibility (value) {
      if (value && this.selectedWorkers.length === 0) {
        this.$refs.alertWindow.show('Ошибка', 'Не выбран ни один рабочий', true)
        return
      }
      let workersWorkingHoursList = []
      let promises = []
      // предварительно загружаются рабочие смены
      this.selectedWorkers.forEach((id) => {
        promises.push(
          api.getWorker(id).then((worker) => {
            let list = []
            worker.first.workerWorkingTimes.forEach((x) => {
              list.push(worker.second.workingTimes[x - 1])
            })
            workersWorkingHoursList.push({
              id: id,
              workingHours: list
            })
          }))
      })
      Promise.all(promises).then(() => {
        if (!workersWorkingHoursList.every((x) => (x.workingHours.length === 1))) {
          this.$refs.alertWindow.show('Ошибка', 'Выберите рабочих только с одной рабочей сменой', true)
          return
        }
        this.isScheduleTemplateWindowVisible = value
        this.changeShadowVisibility(value)
        if (!value) {
          window.setTimeout(() => {
            this.updateWorkers(this.workersBaseFilters.dateFrom, this.workersBaseFilters.dateTo)
          }, 500)
        }
      })
    },
    changeScheduleWindowVisibility (value, worker, day, schedule) {
      if (value && (worker.inBlackList || (worker.dismiss && moment(day, 'YYYY-MM-DD').isAfter(moment().set({
        'year': worker.dismissDate[0],
        'month': worker.dismissDate[1] - 1,
        'date': worker.dismissDate[2]
      }), 'day')))) {
        return
      }
      if (value) {
        this.clickedWorker = worker
        this.clickedWorkerDay = day
        this.clickedWorkerSchedule = schedule
        this.$store.commit('updateDailyScheduleListForWorker', schedule)
      } else {
        this.$store.commit('updateDailyScheduleListForWorker', [])
        this.updateWorkers(this.workersBaseFilters.dateFrom, this.workersBaseFilters.dateTo)
      }
      this.isScheduleWindowVisible = value
      this.changeShadowVisibility(value)
    },
    changeShadowVisibility (value) {
      let body = document.getElementsByTagName('body')[0]
      value ? body.classList.add('schadow') : body.classList.remove('schadow')
    },

    onChangeDateFilterFrom () {
      this.isActualDataPresent = false
      this.workersBaseFilters.dateFrom = new Date(this.workersBaseFilters.dateFrom).getTime()
      let dateTo = new Date(this.workersBaseFilters.dateTo).getTime()
      if (this.workersBaseFilters.dateFrom > dateTo) {
        let tmp = this.workersBaseFilters.dateFrom
        this.workersBaseFilters.dateFrom = dateTo
        this.workersBaseFilters.dateTo = tmp
      }
      /*
        // если первое поставили позднее чем второе, то второе = первое + неделя
        // если период <= недели, то выставляется автоматически недельным, иначе - месячным
        this.isActualDataPresent = false;

        this.workersBaseFilters.dateTo = new Date(this.workersBaseFilters.dateTo).getTime();
        this.workersBaseFilters.dateFrom = new Date(this.workersBaseFilters.dateFrom).getTime();

        let diff = this.workersBaseFilters.dateTo - this.workersBaseFilters.dateFrom;
        let oneWeekInMillis = 6 * 24 * 60 * 60 * 1000;

        if (diff <= oneWeekInMillis) {
          this.workersBaseFilters.dateTo = this.workersBaseFilters.dateFrom + oneWeekInMillis;
        } else {
          let tmpDate = new Date(this.workersBaseFilters.dateFrom);
          let newMonth = tmpDate.getMonth() < 11 ? tmpDate.getMonth() + 1 : 0;
          tmpDate.setMonth(newMonth);
          this.workersBaseFilters.dateTo = tmpDate.getTime();
        }
        */
    },

    onChangeDateFilterTo () {
      this.isActualDataPresent = false
      this.workersBaseFilters.dateTo = new Date(this.workersBaseFilters.dateTo).getTime()
      let dateFrom = new Date(this.workersBaseFilters.dateFrom).getTime()
      if (this.workersBaseFilters.dateTo < dateFrom) {
        let tmp = this.workersBaseFilters.dateTo
        this.workersBaseFilters.dateTo = dateFrom
        this.workersBaseFilters.dateFrom = tmp
      }
      /*
        // если второе поставили раньше чем первое, то первое = второе - неделя
        // если период <= недели, то выставляется автоматически недельным, иначе - месячным
        this.isActualDataPresent = false;

        this.workersBaseFilters.dateTo = new Date(this.workersBaseFilters.dateTo).getTime();
        this.workersBaseFilters.dateFrom = new Date(this.workersBaseFilters.dateFrom).getTime();

        let diff = this.workersBaseFilters.dateTo - this.workersBaseFilters.dateFrom;
        let oneWeekInMillis = 6 * 24 * 60 * 60 * 1000;

        if (diff <= oneWeekInMillis) {
          this.workersBaseFilters.dateFrom = this.workersBaseFilters.dateTo - oneWeekInMillis;
        } else {
          let tmpDate = new Date(this.workersBaseFilters.dateTo);
          let newMonth = tmpDate.getMonth() > 0 ? tmpDate.getMonth() - 1 : 11;
          tmpDate.setMonth(newMonth);
          this.workersBaseFilters.dateFrom = tmpDate.getTime();
        }
        */
    },
    selectAll () {
      let selectedWorkers = [];

      if (!this.isSelectAll
        && this.filteredWorkers
        && this.filteredWorkers.length > 0) {

        selectedWorkers = this.filteredWorkers.map((worker) => worker.id);
      }

      this.selectedWorkers = selectedWorkers;
    },

    openWorker(workerId){
      this.$router.push(`/workers-base/worker-card/` + workerId)
    },

    addDatePickerWatchers() {
      // нужны для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

      this.$watch(
        () => {
          return this.$refs.datePickerFrom.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.workersBaseFilters.dateFrom = tmpValueForDatePicker;
            this.$refs.datePickerFrom.popupVisible = false;
            this.onChangeDateFilterFrom();
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePickerFrom.userInput = '';
            this.$refs.datePickerFrom.currentValue = null;
          }
        }
      );

      this.$watch(
        () => {
          return this.$refs.datePickerTo.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.workersBaseFilters.dateTo = tmpValueForDatePicker;
            this.$refs.datePickerTo.popupVisible = false;
            this.onChangeDateFilterTo();
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePickerTo.userInput = '';
            this.$refs.datePickerTo.currentValue = null;
          }
        }
      );
    }
  }
}
</script>
